import { useEffect, useState } from "react";
import { matchMediaQuery } from "@crehana/utils";
function useMediaQuery(options) {
    const nativeMediaQueryList = matchMediaQuery(options);
    const [matches, setMatches] = useState(nativeMediaQueryList.matches);
    useEffect(()=>{
        function listener(event) {
            setMatches(event.matches);
        }
        if ('function' == typeof nativeMediaQueryList.addEventListener) nativeMediaQueryList.addEventListener('change', listener);
        else if ('function' == typeof nativeMediaQueryList.addListener) nativeMediaQueryList.addListener(listener);
        return ()=>{
            if ('function' == typeof nativeMediaQueryList.removeEventListener) nativeMediaQueryList.removeEventListener('change', listener);
            else if ('function' == typeof nativeMediaQueryList.removeListener) nativeMediaQueryList.removeListener(listener);
        };
    }, []);
    return {
        matches,
        nativeMediaQueryList
    };
}
const src_useMediaQuery = useMediaQuery;
export default src_useMediaQuery;
